<template>
  <ul data-component-name="Copyright">
    <li v-for="({ path, i18nKey }, index) in Links" :key="index">
      <NavItem
        :to="localePathWithSlash(path)"
        external
        size="small"
        variant="reversed"
      >
        {{ $t(i18nKey) }}
      </NavItem>
    </li>

    <li class="copyright">
      <p>&copy; {{ year }} Object First (US) Inc.</p>
    </li>
  </ul>
</template>

<script setup lang="ts">
// Components
import NavItem from '~/components/redesign/NavItem.vue';

import { PATHS, LINKS } from '~/constants';
import useLocalePathWithSlash from '~/composables/useLocalePathWithSlash';

const Links = [
  PATHS.PRIVACY_POLICY,
  { path: LINKS.DSAR_FORM, i18nKey: 'DSAR_Form' },
];

const year = new Date().getFullYear();
const localePathWithSlash = useLocalePathWithSlash();
</script>

<style scoped lang="scss">
@use '_/fn';
@use '_/mixins/flex';
@use '_/mixins/typo';
@use '_/mixins/media';

[data-component-name='Copyright'] {
  @include flex.center-center;
  flex-direction: row;
  gap: 0.5rem;

  @include media.tablet {
    flex-wrap: wrap;
    @include flex.center-start;
  }

  @include media.mobile {
    @include flex.center-center;
    max-width: 17rem;
  }

  :deep(li) {
    @include media.mobile {
      [data-component-name='NavItem'] {
        padding-left: 0.5rem;
        padding-right: 0.5rem;
      }
    }
  }

  li.copyright {
    order: unset;

    @include media.mobile {
      order: -1;
    }
  }

  p {
    @include typo.body-4;
    color: fn.token('text-reversed');
    padding-inline: 1rem;
  }
}
</style>
